// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/chat/entity/v2/room.proto (package social.chat.entity.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { PlaceholderMaskedText } from "./text_mask_pb.js";
import { VerifiedStatus } from "../../../verified_badge/enum/v1/verified_status_pb.js";

/**
 * @generated from enum social.chat.entity.v2.RoomType
 */
export const RoomType = /*@__PURE__*/ proto3.makeEnum(
  "social.chat.entity.v2.RoomType",
  [
    {no: 0, name: "ROOM_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ROOM_TYPE_PERSONAL", localName: "PERSONAL"},
    {no: 2, name: "ROOM_TYPE_GROUP", localName: "GROUP"},
    {no: 3, name: "ROOM_TYPE_BROADCAST", localName: "BROADCAST"},
  ],
);

/**
 * @generated from enum social.chat.entity.v2.RoomState
 */
export const RoomState = /*@__PURE__*/ proto3.makeEnum(
  "social.chat.entity.v2.RoomState",
  [
    {no: 0, name: "ROOM_STATE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ROOM_STATE_ACCEPTED", localName: "ACCEPTED"},
    {no: 2, name: "ROOM_STATE_INVITED", localName: "INVITED"},
  ],
);

/**
 * @generated from message social.chat.entity.v2.RoomInfo
 */
export const RoomInfo = /*@__PURE__*/ proto3.makeMessageType(
  "social.chat.entity.v2.RoomInfo",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "shortened_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "avatar_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.chat.entity.v2.BaseRoom
 */
export const BaseRoom = /*@__PURE__*/ proto3.makeMessageType(
  "social.chat.entity.v2.BaseRoom",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "type", kind: "enum", T: proto3.getEnumType(RoomType) },
    { no: 3, name: "info", kind: "message", T: RoomInfo },
    { no: 4, name: "state", kind: "enum", T: proto3.getEnumType(RoomState) },
  ],
);

/**
 * @generated from message social.chat.entity.v2.Room
 */
export const Room = /*@__PURE__*/ proto3.makeMessageType(
  "social.chat.entity.v2.Room",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "type", kind: "enum", T: proto3.getEnumType(RoomType) },
    { no: 3, name: "info", kind: "message", T: RoomInfo },
    { no: 4, name: "attributes", kind: "message", T: RoomAttribute },
    { no: 5, name: "unread_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "last_message", kind: "message", T: LastMessage },
    { no: 7, name: "status", kind: "message", T: RoomStatus },
    { no: 8, name: "state", kind: "enum", T: proto3.getEnumType(RoomState) },
    { no: 9, name: "unread_message", kind: "message", T: UnreadMessage },
  ],
);

/**
 * @generated from message social.chat.entity.v2.UnreadMessage
 */
export const UnreadMessage = /*@__PURE__*/ proto3.makeMessageType(
  "social.chat.entity.v2.UnreadMessage",
  () => [
    { no: 1, name: "total", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "last_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message social.chat.entity.v2.LastMessage
 */
export const LastMessage = /*@__PURE__*/ proto3.makeMessageType(
  "social.chat.entity.v2.LastMessage",
  () => [
    { no: 1, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "sender_username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "type", kind: "enum", T: proto3.getEnumType(LastMessage_AttachmentType) },
    { no: 4, name: "created_at", kind: "message", T: Timestamp },
    { no: 5, name: "is_deleted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "placeholder_mask", kind: "message", T: PlaceholderMaskedText },
  ],
);

/**
 * @generated from enum social.chat.entity.v2.LastMessage.AttachmentType
 */
export const LastMessage_AttachmentType = /*@__PURE__*/ proto3.makeEnum(
  "social.chat.entity.v2.LastMessage.AttachmentType",
  [
    {no: 0, name: "ATTACHMENT_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ATTACHMENT_TYPE_PHOTO", localName: "PHOTO"},
    {no: 2, name: "ATTACHMENT_TYPE_GIF", localName: "GIF"},
    {no: 3, name: "ATTACHMENT_TYPE_POST", localName: "POST"},
    {no: 4, name: "ATTACHMENT_TYPE_SHARETRADE", localName: "SHARETRADE"},
    {no: 5, name: "ATTACHMENT_TYPE_PDF", localName: "PDF"},
    {no: 6, name: "ATTACHMENT_TYPE_STICKER", localName: "STICKER"},
  ],
);

/**
 * @generated from message social.chat.entity.v2.RoomStatus
 */
export const RoomStatus = /*@__PURE__*/ proto3.makeMessageType(
  "social.chat.entity.v2.RoomStatus",
  () => [
    { no: 1, name: "is_muted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "is_mentioned", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message social.chat.entity.v2.RoomAttribute
 */
export const RoomAttribute = /*@__PURE__*/ proto3.makeMessageType(
  "social.chat.entity.v2.RoomAttribute",
  () => [
    { no: 1, name: "personal", kind: "message", T: PersonalRoomAttribute, oneof: "attr" },
    { no: 2, name: "group", kind: "message", T: GroupRoomAttribute, oneof: "attr" },
  ],
);

/**
 * @generated from message social.chat.entity.v2.PersonalRoomAttribute
 */
export const PersonalRoomAttribute = /*@__PURE__*/ proto3.makeMessageType(
  "social.chat.entity.v2.PersonalRoomAttribute",
  () => [
    { no: 1, name: "user_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "is_verified", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "is_admin", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "is_deactivated", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "is_blocked", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "verified_status", kind: "enum", T: proto3.getEnumType(VerifiedStatus) },
  ],
);

/**
 * @generated from message social.chat.entity.v2.GroupRoomAttribute
 */
export const GroupRoomAttribute = /*@__PURE__*/ proto3.makeMessageType(
  "social.chat.entity.v2.GroupRoomAttribute",
  () => [
    { no: 1, name: "member_description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

